import { Iterable } from "@siteimprove/alfa-iterable";
import { None, Option } from "@siteimprove/alfa-option";
import { FontFaceRule, ImportRule, KeyframeRule, KeyframesRule, Layer, MediaRule, NamespaceRule, PageRule, StyleRule, SupportsRule, } from "../index.js";
/**
 * @public
 */
export class Rule {
    _owner = None;
    _parent = None;
    _type;
    constructor(type) {
        this._type = type;
    }
    get type() {
        return this._type;
    }
    get owner() {
        return this._owner;
    }
    get parent() {
        return this._parent;
    }
    *children() { }
    *descendants() {
        for (const child of this.children()) {
            yield child;
            yield* child.descendants();
        }
    }
    *ancestors() {
        for (const parent of this._parent) {
            yield parent;
            yield* parent.ancestors();
        }
    }
    *inclusiveAncestors() {
        yield this;
        yield* this.ancestors();
    }
    equals(value) {
        return value === this;
    }
    toJSON() {
        return { type: this._type };
    }
    /**
     * @internal
     */
    _attachOwner(owner) {
        if (this._owner.isSome()) {
            return false;
        }
        this._owner = Option.of(owner);
        // Recursively attach the owner to all children.
        return Iterable.every(this.children(), (rule) => rule._attachOwner(owner));
    }
    /**
     * @internal
     */
    _attachParent(parent) {
        if (this._parent.isSome()) {
            return false;
        }
        this._parent = Option.of(parent);
        return true;
    }
}
/**
 * @public
 */
(function (Rule) {
    function from(json) {
        return fromRule(json).run();
    }
    Rule.from = from;
    /**
     * @internal
     */
    function fromRule(json) {
        switch (json.type) {
            case "font-face":
                return FontFaceRule.fromFontFaceRule(json);
            case "import":
                return ImportRule.fromImportRule(json);
            case "keyframe":
                return KeyframeRule.fromKeyframeRule(json);
            case "keyframes":
                return KeyframesRule.fromKeyframesRule(json);
            case "layer-block":
                return Layer.BlockRule.fromLayerBlockRule(json);
            case "layer-statement":
                return Layer.StatementRule.fromLayerStatementRule(json);
            case "media":
                return MediaRule.fromMediaRule(json);
            case "namespace":
                return NamespaceRule.fromNamespaceRule(json);
            case "page":
                return PageRule.fromPageRule(json);
            case "style":
                return StyleRule.fromStyleRule(json);
            case "supports":
                return SupportsRule.fromSupportsRule(json);
            default:
                throw new Error(`Unexpected rule of type: ${json.type}`);
        }
    }
    Rule.fromRule = fromRule;
})(Rule || (Rule = {}));
//# sourceMappingURL=rule.js.map